import { Link, useSearchParams } from "react-router-dom";
import styles from "../styles/remedial-quote.module.scss";

export default function RemedialCheckoutCancelPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>Payment Cancelled</h1>
        <p>Your payment was not completed. Your quote is still available.</p>
        {token ? (
          <p>
            <Link className={styles.link} to={`/remedial-quote/${token}`}>
              Return to your remedial quote
            </Link>
          </p>
        ) : null}
        <p>
          <Link className={styles.link} to="/contact-us">Need help? Contact Teck Engineers</Link>
        </p>
      </div>
    </div>
  );
}
